import React, { useState } from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'

export function Step({
  quote,
  time,
  unit,
  title,
  icon,
  km
}: {
  quote: React.Node,
  time: string,
  unit: string,
  title: string,
  icon: string,
  km: string
}) {
  const [active, setActive] = useState(false)

  return (
    <div id='step'>
      <div className='stepWrapper'>
        <div className='timestamp'>
          <div className='time'>{time}</div>
          <div className='unit'>{unit}</div>
        </div>

        <div className='titleContainer'>
          <h3>{title}</h3>
          {icon === '' ? (
            ''
          ) : (
            <>
              <i className={'icon ' + icon} />
              <span>{km} km bis Kiew</span>
            </>
          )}
        </div>

        <Waypoint
          onEnter={event => {
            setActive(active => !active)
          }}
          onLeave={event => {
            setActive(active => active)
          }}
        />
      </div>
    </div>
  )
}
